export const LEADERSHIP_PAGE = {
    // ── Hero ─────────────────────────────────────────────────────────────────
    hero: {
        tag: "About AI.Prof",
        headline1: "We're not building",
        headline2: "another EdTech.",
        headlineHighlight: "We're building infrastructure.",
        paragraphs: [
            "India graduates over a million engineers a year. Most aren't ready for the jobs that exist -- not because they're not brilliant, but because the system they studied in was built for a world that no longer exists.",
            "AI.Prof is the infrastructure layer changing how students learn, universities track progress, and companies discover talent. Built for India, designed for the world.",
        ],
    },

    // ── Vision / Mission ─────────────────────────────────────────────────────
    visionMission: {
        vision: {
            tag: "Vision",
            text: "To become the infrastructure layer between Indian engineering talent and the global technology industry.",
            bgClass: "bg-aipeach/30",
            borderClass: "border-aipeach",
        },
        mission: {
            tag: "Mission",
            text: "To rebuild the bridge between education and employment in India by integrating AI into learning, assessment, portfolio building, and hiring from Semester 1.",
            bgClass: "bg-aiblue text-white",
        },
    },

    // ── Founder ──────────────────────────────────────────────────────────────
    founder: {
        tag: "The Person Behind AI.Prof",
        name: "Sandeep Konam",
        title: "Founder & Chairman, AI.Prof · Co-Founder, Abridge · Founder & Chairman, KONAM Foundation",
        bioParagraphs: [
            "Born and raised in rural Nalgonda, Telangana — Sandeep is living proof that where you start doesn't have to determine where you go. He trained in Robotics at Carnegie Mellon University, co-founded Abridge (an AI healthcare unicorn valued at $5.3B and featured in the NYT, Forbes, and WSJ), and was named to Forbes' 2021 30 Under 30 in Healthcare.",
            "He has delivered guest lectures at CMU, Stanford, and UPitt. His writing has appeared in Quartz, Fast Company, and Fierce Healthcare. He runs the KONAM Foundation to accelerate sustainable development through technology across India and Africa.",
            "With AI.Prof, he's come back to where it all started — to raise the bar for the engineering student.",
        ],
        quote: {
            text: "India has never had a shortage of brilliant engineers. It's had a shortage of systems that could find them. That ends now.",
            cite: "— Sandeep Konam, Founder & Chairman, AI.Prof",
        },
        forbesBadge: {
            label: "Forbes",
            sublabel: "30 Under 30 · 2021",
        },
    },

    // ── Journey Gallery ──────────────────────────────────────────────────────
    journeyGallery: {
        tag: "The Journey",
        headline: "From Nalgonda to the world.",
        description:
            "A visual story of grit, ambition, and vision for the next generation.",
        images: [
            {
                src: "images/Raj%20Reddy.jpeg",
                alt: "Sandeep at Carnegie Mellon University graduation with Dr. Raj Reddy",
                caption:
                    "🎓 Sandeep Konam with AI Legend Dr. Raj Reddy at His Graduation from Carnegie Mellon University",
                colSpan: "col-span-1",
                delay: 0.05,
            },
            {
                src: "images/Revanth_Redyy.JPG",
                alt: "Skill Development in Telangana",
                caption: "Skill Development in Telangana with AI.Prof",
                colSpan: "col-span-1",
                delay: 0.15,
            },
            {
                src: "images/IT_ECE.jpg",
                alt: "Meeting with IT Minister",
                caption: "Minister for Information Technology, Electronics, Communications, Industries and Commerce, Government of Telangana",
                colSpan: "col-span-1",
                delay: 0.25,
            },
        ],
    },

    // ── CMU Section ──────────────────────────────────────────────────────────
    cmuSection: {
        tag: "The world-class foundation",
        headline:
            "Trained at one of the world's top AI labs — returning to India to build something bigger.",
        description:
            "At CMU's Robotics Institute, Sandeep worked at the frontier of AI — enhancing drone perception, multi-robot coordination, and clinical trial matching. He didn't stay abroad. He brought it all back.",
        caption:
            "Receiving his MS in Robotics at Carnegie Mellon University, 2017",
    },

    // ── Community / KONAM ────────────────────────────────────────────────────
    community: {
        tag: "KONAM Foundation",
        headline: "Building for India means building for everyone it forgets.",
        description:
            "The KONAM Foundation trains farmers, youth, and underserved communities in AI and digital skills — from Nalgonda to Africa. Because Sandeep knows firsthand what access to the right tools can change.",
    },

    // ── Timeline (this section was hideed no need ti change the text)////─────────────────────────────────────────────────────────────
    timeline: [
        {
            year: "Nalgonda",
            label: "Roots",
            desc: "Born and raised in rural Telangana. First-generation engineer who refused to let a zip code decide his ceiling.",
        },
        {
            year: "IIIT RGUKT · RKVALLEY",
            label: "B.Tech",
            desc: "Electronics & Communication Engineering at IIIT RGUKT (RKVALLEY), with a minor in Computer Science — where the obsession with AI began.",
        },
        {
            year: "CMU · 2017",
            label: "MS Robotics",
            desc: "Master's in Robotics at Carnegie Mellon's Robotics Institute under Prof. Manuela Veloso. Built EXAID — an AI app matching cancer patients with clinical trials. McGinnis Venture Competition finalist.",
        },
        {
            year: "2018",
            label: "Co-founded Abridge",
            desc: "Co-founded Abridge with Dr. Shiv Rao — AI that extracts life-saving insights from doctor-patient conversations. Now an AI healthcare unicorn valued at $5.3B. Featured in Forbes, NYT, WSJ.",
        },
        {
            year: "2021",
            label: "Forbes 30 Under 30",
            desc: "Named to Forbes' 30 Under 30 in Healthcare for building AI infrastructure that keeps patients and families in the loop — even during Covid.",
        },
        {
            year: "KONAM Foundation",
            label: "Giving Back",
            desc: "Founded the KONAM Foundation to accelerate SDGs — training youth in AI, agriculture tech, and digital skills across Telangana and beyond.",
        },
        {
            year: "2024+",
            label: "AI.Prof · Hitloop",
            desc: "Founded AI.Prof and Hitloop — returning to India to build the infrastructure for how the next generation of engineers learns, proves their skills, and gets hired.",
        },
    ],

    // ── Press / Media ────────────────────────────────────────────────────────
    press: {
        tag: "As seen in",
        outlets: [
            { name: "Forbes", label: "30 Under 30 · 2021" },
            { name: "Wall Street Journal", label: "Featured" },
            { name: "Carnegie Mellon", label: "Robotics Institute Alumni" },
            { name: "Fast Company", label: "Contributor" },
            { name: "Telangana Today", label: "Featured" },
            { name: "General Highlights", label: "Media Coverage" },
        ],
        images: [
            "images/forbes-about-abridge.png",
            "images/WallStreet.png",
            "images/sandeep-portrait.jpg",
            "images/FastCompany.png",
            "images/TelanganaToday.png",
            "images/UPMC.png",
        ],
    },

    // ── CTA ──────────────────────────────────────────────────────────────────
    cta: {
        tag: "Join us",
        headline:
            "Somewhere in a Tier-3 city right now, the most talented engineer in India has no idea how to prove it.",
        description: "We built this for them. Be part of what changes that.",
        buttonText: "Let's Build Together →",
    },

    // ── Image paths ──────────────────────────────────────────────────────────
    imagePaths: {
        sandeepForbes: "images/sandeep-portrait.jpg",
        sandeepCMU: "images/sandeep-cmu-graduation.jpg",
    },

    // ── Carousel images (community section) ─────────────────────────────────
    carouselImages: [
        {
            src: "images/sandeep-community.png",
            alt: "Sandeep with KONAM Foundation participants",
        },
        {
            src: "images/Krishi.png",
            alt: "KONAM Foundation Agriculture Initiative",
        },
    ],
};
